//import projects
import Template from './Template';
import prompts from '../../../dummy_data/prompt_engineer/manage.json';

// External variant
const options = [
    'Đặt mục tiêu rõ ràng',
    'Nhận diện thương hiệu',
    'Chọn công cụ phù hợp',
    'Tìm ngách lợi nhuận',
    'Đi đầu xu hướng ngành',
    'Tổ chức kinh doanh',
    'Lên kế hoạch kinh doanh thành công'
];

const prompt_persona_role =
    'Phản hồi như một nhà quản trị kinh doanh chuyên nghiệp, giúp xây dựng và phát triển một tổ chức kinh doanh hiệu quả và bền vững.';

export default function Manage() {
    return (
        <Template personaRole={prompt_persona_role} data={prompts} title="Quản trị" options={options} project="prompt_engineer/manage" />
    );
}
